angular.module('dentalLinks')
    .controller('AttachmentsController', ['$scope', '$http', '$window', 'Notification', 'Auth', 'FileUploader', 'Logger', 'API_ENDPOINT', 'Attachment', '$uibModal', 'ModalHandler', 'ProgressIndicator', 'UploadService', 'CbctStripService', 'ReferralHelper',
    function ($scope, $http, $window, Notification, Auth, FileUploader, Logger, API_ENDPOINT, Attachment, $uibModal, ModalHandler, ProgressIndicator, UploadService, CbctStripService, ReferralHelper) {
        $scope.now = function () {
            return Date.now();
        };

        $scope.openDatePicker = function(attachment){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/date_picker.html',
                controller: 'DatePickerModalController',
                windowClass: 'date-picker-modal',
                resolve: {
                    currentDate: function(){
                        return attachment.metadata.last_modified;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (date) {
                attachment.metadata.last_modified = date; //we need write-enabled property so it is necessary
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        // DCL-477: the "Change Date" pencil on an uploaded attachment. Shown to
        // the uploading practice (see canEditAttachmentDate) and, on this page,
        // also while the attachment is `invalid` — a JPEG with no creation date
        // blocks sending (isInvalidAttachments), so it must stay fixable.
        $scope.canEditAttachmentDate = function (attachment) {
            return ReferralHelper.canEditAttachmentDate($scope.auth, attachment);
        };

        $scope.editLastModified = function(event, attachment){
            event.preventDefault();
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/date_picker.html',
                controller: 'DatePickerModalController',
                windowClass: 'date-picker-modal',
                resolve: {
                    currentDate: function(){
                        // Open on the date already recorded, so a correction starts
                        // from the current value instead of jumping to today.
                        return attachment.last_modified || new Date().toISOString();
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (date) {
                Attachment.update({id: attachment.id}, {last_modified: date},
                    function(success){
                        attachment.last_modified = success.last_modified;
                        attachment.invalid = false;
                    });
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.isInvalidAttachments = function(){
            if(!$scope.attachments) {
                return false;
            }
            var attachmentsState = $scope.attachments.reduce(function(prev, current){
                return prev || current.invalid;
            }, false);
            if(attachmentsState) {
                Notification.error('Attached image does not have a creation date. Please enter the correct date.');
            } else {
                Notification.close();
            }

            return attachmentsState;
        };

        $scope.deleteAttachment = function(attachment){
            // Give the bytes back to the running total (DCL-230) — without this it
            // only ever grows, and eventually rejects uploads the referral has
            // room for.
            if(typeof attachment.id === 'undefined'){
                $scope.uploader.releaseSize(attachment);
                $scope.uploader.queue.splice($scope.uploader.queue.indexOf(attachment),1);
                return;
            }

            // The row stays until the response, so a second click can get here too.
            function removeSaved() {
                var index = $scope.attachments.indexOf(attachment);
                if (index === -1) {
                    return;
                }
                $scope.uploader.releaseSize(attachment);
                $scope.attachments.splice(index, 1);
            }

            Attachment.delete({id: attachment.id}, removeSaved, function (failure) {
                // A 404 means it's already gone, so the row should go too.
                if (failure.status === 404) {
                    removeSaved();
                    return;
                }
                Notification.error((failure.data && failure.data.message) ||
                    'An error occurred while deleting the attachment...');
            });
        };

        // Opening an attachment (DCL-440): guests can't send the X-Draft-Edit-Token
        // header from a plain link, so when guest headers are present we fetch the
        // file as a blob with the token and hand it to a synchronously-opened window
        // (opening in the click handler keeps popup blockers happy). Authenticated
        // pages have no draftUploadHeaders — the plain href/target navigates as before.
        $scope.openAttachment = function(attachment, $event){
            var headers = $scope.draftUploadHeaders && $scope.draftUploadHeaders();
            if (!headers || angular.equals(headers, {})) {
                return; // authenticated: let the plain link navigate
            }
            $event.preventDefault();
            var win = $window.open('', '_blank');
            var url = API_ENDPOINT + '/attachment/?file=' + attachment.id + '/' + attachment.attach_file_name;
            $http({method: 'GET', url: url, responseType: 'blob', headers: headers, withCredentials: true})
                .then(function (response) {
                    var objectUrl = $window.URL.createObjectURL(response.data);
                    if (win) { win.location = objectUrl; }
                }, function () {
                    if (win) { win.close(); }
                    Notification.error('Unable to open attachment. Please try again.');
                });
        };

        // Downloading has the same guest-token problem as openAttachment: the
        // plain href (with its `download` attribute) can't carry the header, so
        // with guest headers present we fetch a blob and download it through a
        // transient anchor. Authenticated pages let the plain link navigate.
        $scope.downloadAttachment = function(attachment, $event){
            var headers = $scope.draftUploadHeaders && $scope.draftUploadHeaders();
            if (!headers || angular.equals(headers, {})) {
                return; // authenticated: let the plain link download
            }
            $event.preventDefault();
            var url = API_ENDPOINT + '/attachment/?file=' + attachment.id + '/' + attachment.attach_file_name + '&download=true';
            $http({method: 'GET', url: url, responseType: 'blob', headers: headers, withCredentials: true})
                .then(function (response) {
                    var objectUrl = $window.URL.createObjectURL(response.data);
                    var link = $window.document.createElement('a');
                    link.href = objectUrl;
                    link.download = attachment.attach_file_name;
                    $window.document.body.appendChild(link);
                    link.click();
                    $window.document.body.removeChild(link);
                    $window.URL.revokeObjectURL(objectUrl);
                }, function () {
                    Notification.error('Unable to download attachment. Please try again.');
                });
        };

        $scope.onDropZoneClick = function($event){
            // Only trigger file input if clicking the drop zone itself (UL tag), not child elements
            if ($event.target === $event.currentTarget || $event.target.tagName === 'UL') {
                document.getElementById('attachment-file-input').click();
            }
        };

        $scope.current_user = Auth.current_user;

        var auth = Auth.get();
        $scope.auth = auth || {};
        $scope.from = auth ? auth.email : '';

        // CBCT scan strip (DCL-211): lives below the drop area, separate from the
        // regular attachments uploader/queue. Hidden for guests (no auth cookie).
        // Unique input ids so the create-referral and view-referral hosts never
        // collide in the DOM.
        $scope.cbctFolderInputId = 'create-cbct-folder-input';
        $scope.cbctFileInputId = 'create-cbct-file-input';

        // DCL-523: a scan may be attached when EITHER practice on the referral is
        // Premium, so a Basic sender's slot stays locked until they pick a Premium
        // destination — and re-locks (dropping the scan) if they move to a Basic
        // one. This directive shares the create/review controller's scope, so the
        // destination it reads is the same `destinationPractice` the practice
        // typeahead maintains.
        //
        // Three-valued on purpose: `null` means "no settled destination yet". The
        // typeahead assigns `destinationPractice = []` on every keystroke, and
        // reporting that as false would drop a scan while the user is merely
        // retyping a practice name.
        function ownPracticeIsPremium() {
            var u = Auth.current_user;
            return !!(u && u.practice && u.practice.premium_access);
        }

        function destinationIsPremium() {
            // Pending registration: no practice, so no subscription to lean on.
            if ($scope.model && $scope.model.referral && $scope.model.referral.dest_provider_invited_id) {
                return false;
            }
            var dest = $scope.destinationPractice;
            if (!dest || angular.isArray(dest) || !dest.id) { return null; }
            return !!dest.premium_access;
        }

        CbctStripService.attach($scope, {
            folderInputId: $scope.cbctFolderInputId,
            fileInputId: $scope.cbctFileInputId,
            eligibilityFn: function () {
                if (ownPracticeIsPremium()) { return true; }
                return destinationIsPremium();
            }
        });

        // DCL-214: show/poll/delete need the referral id. The parent create/
        // review controller owns model.referral (id set lazily on create;
        // already present on resume). Delete permission rides on the scan JSON
        // itself (`can_delete`, uploader's practice only).
        $scope.cbctReferralId = function () {
            return ($scope.model && $scope.model.referral && $scope.model.referral.id) || null;
        };

        // Resume (review-referral): hydrate the strip from a persisted CBCT scan.
        var resumedScan = $scope.model && $scope.model.referral && $scope.model.referral.cbct_scan;
        if (resumedScan) {
            $scope.cbctInitFromScan(resumedScan);
        }

        $scope.model.attachments = [];
        $scope.total_size = 0;

        angular.forEach($scope.attachments, function (attachment, key) {
            $scope.total_size += attachment.attach_file_size;

            $scope.attachments[key].invalid = !$scope.attachments[key].last_modified && $scope.attachments[key].attach_content_type == "image/jpeg";
        });

        var uploader = $scope.uploader = UploadService.createUploader({
            scope: $scope,
            url: API_ENDPOINT + '/attachment/upload',
            alias: 'attach',
            formData: [
                {filename: ''}
            ],
            immediateUpload: false,
            onSuccessItem: function(item, response){ item.downloadUrl = response.attach_file_name; },
            onCompleteItem: function(item, response, status){ if (status == 201 && $scope && $scope.attachments) { $scope.attachments.push(response); } },
            onCompleteAll: function(){ var queue = uploader.queue; queue.length = 0; ProgressIndicator.finish(); if (queue.redirectCallback){ queue.redirectCallback($scope.errorMessage); } }
        });

        $scope.attachment_error = false;

// File-size limits and filters live in UploadService.createUploader
// (MAX_ATTACHMENT_FILE_SIZE per file, MAX_REFERRAL_ATTACHMENTS_SIZE total).

// REGISTER HANDLERS

        uploader.onAfterAddingFile = function(item){
            // Logger.info('After adding a file', item);
            item.metadata = {last_modified: item.file.lastModifiedDate}; //workaround - we need writable property (File object has read-only File.lastModifiedDate) to be able to change the date of the file according to https://www.pivotaltracker.com/story/show/84423098
            item.formData.push(item.metadata);

            // DCL-369 live drafts: the first attachment creates the draft, and every
            // attachment uploads immediately against the draft id (like view-referral).
            if ($scope.ensureDraftForUpload) {
                $scope.ensureDraftForUpload().then(function (referralId) {
                    item.formData.push({referral_id: referralId});
                    if ($scope.draftUploadHeaders) {
                        item.headers = angular.extend({}, item.headers, $scope.draftUploadHeaders());
                    }
                    ProgressIndicator.start();
                    item.upload();
                }, function () {
                    // Draft can't be created yet (guest identity incomplete) — the file
                    // stays queued; the guest controller flushes the queue on creation.
                });
            }
        };

        // No onWhenAddingFileFailed override here: UploadService's own handler is
        // the same generic fallback, except it keeps quiet when its size/type
        // filters were the ones that rejected the file — those are reported by
        // name in a single deferred message instead (DCL-230).

        uploader.onAfterAddingAll = function(items) {
            // Logger.info('After adding all files', items);
            $scope.form.$setDirty(); // for UnsavedChanges to notice attachments being changed
        };

        uploader.onBeforeUploadItem = function(item) {

            // Logger.debug('FORM DATA:', uploader.formData);
            // Logger.debug('SCOPE DATA:', $scope.s3Credentials);
            // Logger.info('Before upload', item);

            // show the loading indicator
            ProgressIndicator.start();

        };

        uploader.onProgressItem = function(item, progress){
            // Logger.info('Progress: ' + progress, item);
        };

        uploader.onSuccessItem = function(item, response, status, headers) {
            // Logger.info('Success', item, response);
            item.downloadUrl = response.attach_file_name;
        };

        uploader.onCancelItem = function(item, response, status, headers) {
            // Logger.info('Cancel', response, item);
            Notification.info('Attachment was cancelled.')
        };

        uploader.onErrorItem = function(item, response, status, headers) {
            Logger.error('Error', response, item, status);
            ProgressIndicator.finish();
            // Prefer a server-supplied friendly message (e.g. the DCL-215 monthly
            // upload-cap or per-referral size-limit rejection, both { message }),
            // then Paperclip field errors, then a generic fallback.
            $scope.errorMessage = response.message? response.message : response.file? response.file[0] : response.attach? 'Sorry this file type is not allowed as an attachment.' : 'An error occurred during attachment upload. Please try again later.';
            Notification.error( $scope.errorMessage, {dontHideOnRequest: true});
        };

        uploader.onCompleteItem = function(item, response, status, headers){
            // Logger.info('Complete', status, item, response);
            if (status == 201 && $scope && $scope.attachments) {
                $scope.attachments.push(response);
            }
        };

        uploader.onProgressAll = function(progress) {

            // Logger.info('Total progress: ' + progress);

            // show the loading indicator
           ProgressIndicator.set(progress);
        };

        uploader.onCompleteAll = function()  {
            // Logger.info('Complete all', uploader.queue);
            uploader.queue.length = 0; //empty uploader queue
            ProgressIndicator.finish();
        };
    }]);
